<ziro-breadcrumbs>
  <ziro-breadcrumb-card-item [aboutCardId]="58"></ziro-breadcrumb-card-item>
</ziro-breadcrumbs>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div class="pb-2">
    <ziro-microsoft-dial-plan-group-management-form
      [entity]="dialPlanGroup"
      [allMsDialplanGroups]="allDialPlanGroups"
      [msCachedOptions]="microsoftCachedOptions"
      [bandwidthCachedOptions]="bandwidthCachedOptions"
      [usageLocations]="usageLocations"
      [isSupportUser]="isSupportUser"
      [isBandwidthConfigured]="isBandwidthConfigured"
      [isGccHigh]="isGccHigh"
      [onPremAdWriteDownEnabled]="onPremAdWriteDownEnabled"
      (ziroFormsUpdate$)="onFormUpdate($event)"
    ></ziro-microsoft-dial-plan-group-management-form>
  </div>
}
